import React from 'react';
import CrtTitle from "./crtTitle";
import SpectrumHover from "./spectrumHover";
import './App.css';
import 'reactbulma';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckSquare, faArrowRight, faCircle, faChevronRight, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import StygianOakLogo from "./assets/stygianoak-logo.png";

import FishMatcherImage from "./assets/fish-matcher.jpg";
import FishMatcherTech1Image from "./assets/fish-matcher-tech1.png";
import FishMatcherTech2Image from "./assets/fish-matcher-tech2.png";
import WrathImage from "./assets/wrath-screenshot.png";

import Lander from "./lander";
import Introduction from "./introduction";
import Products from "./products";
import Advisory from "./advisory";
import Privacy from "./privacy";
import VenturesBackground from "./venturesBackground";
import ContactNoise from "./contactNoise";

library.add(faCheckSquare, faArrowRight, faCircle, faChevronRight, faExternalLinkAlt)

export const ROUTES = {
  introduction: '/',
  advisory: '/advisory',
  ventures: '/ventures',
  privacy: '/privacy',
  contact: '/contact',
  lander: '/moon-lander'
};

const ROUTE_DETAILS = {
  introduction: {
    label: 'INTRODUCTION',
    title: 'Relentless | Business Software and Ventures',
    description: 'Relentless provides business software, risk advisory and assurance services.'
  },
  advisory: {
    label: 'ADVISORY',
    title: 'Advisory and Assurance | Relentless',
    description: 'Risk scenarios, strategy, cyber assurance and fleet assurance from Relentless.'
  },
  ventures: {
    label: 'VENTURES',
    title: 'Ventures | Relentless',
    description: 'Independent technology and creative ventures associated with Relentless.'
  },
  privacy: {
    label: 'PRIVACY',
    title: 'Privacy | Relentless',
    description: 'The privacy policy of Relentless Partners and Relentless Technology.'
  },
  contact: {
    label: 'CONTACT',
    title: 'Contact | Relentless',
    description: 'Contact Relentless Partners.'
  },
  lander: {
    label: 'MOON LANDER!',
    title: 'Moon Lander | Relentless',
    description: 'Play the Relentless moon lander game.',
    className: 'no-lander'
  }
};

const NAV_ITEMS = ['introduction', 'advisory', 'ventures', 'privacy', 'contact', 'lander'];

export function getMenuFromPath(pathname) {
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return Object.keys(ROUTES).find(menu => ROUTES[menu] === normalizedPath) || 'introduction';
}

class App extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      menu: getMenuFromPath(window.location.pathname),
      menuOpen: false
    }

    this.navigateTo = this.navigateTo.bind(this);
    this.handlePopState = this.handlePopState.bind(this);
  }

  navigateTo(menu, event, options = {}) {
    if (event && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) {
      return;
    }

    if (event) {
      event.preventDefault();
    }

    const path = ROUTES[menu] || ROUTES.introduction;
    if (!options.fromHistory && window.location.pathname !== path) {
      window.history.pushState({ menu }, '', path);
    }

    window.scrollTo(0, 0);
    this.setState({ menu, menuOpen: false }, () => this.updateRouteMetadata(menu));
  }

  handlePopState() {
    this.navigateTo(getMenuFromPath(window.location.pathname), null, { fromHistory: true });
  }

  updateRouteMetadata(menu) {
    const route = ROUTE_DETAILS[menu] || ROUTE_DETAILS.introduction;
    document.title = route.title;
    const description = document.querySelector('meta[name="description"]');
    if (description) {
      description.setAttribute('content', route.description);
    }
  }

  toggleMenu() {
    this.setState(state => ({ menuOpen: !state.menuOpen }));
  }

  componentDidMount() {
    window.addEventListener('popstate', this.handlePopState);
    this.updateRouteMetadata(this.state.menu);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handlePopState);
  }
  
  render() {
   
    return (
    <section id="main" className="main">
      <div id="sizer" className="sizer">
      </div>
      
      <nav className="navbar" role="navigation" aria-label="main navigation">
        <div className="navbar-brand">
          <a href="/" onClick={(event) => this.navigateTo('introduction', event)} aria-label="Relentless home">
            <img style={{marginTop: "13px"}} className="title-logo" src="relentless-no-text.png" alt="" />
          </a>

          <button
            type="button"
            className={`navbar-burger burger ${this.state.menuOpen ? 'is-active' : ''}`}
            aria-label={this.state.menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={this.state.menuOpen}
            aria-controls="navbarBasicExample"
            onClick={() => this.toggleMenu()}
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </button>
        </div>

        <div id="navbarBasicExample" className={`navbar-menu ${this.state.menuOpen ? 'is-active' : ''}`}>
          <div className="navbar-start noselect">
            {NAV_ITEMS.map(menu => {
              const route = ROUTE_DETAILS[menu];
              const isActive = this.state.menu === menu;
              return (
                <a
                  key={menu}
                  href={ROUTES[menu]}
                  onClick={(event) => this.navigateTo(menu, event)}
                  className={`navbar-item ${isActive ? 'navbar-live' : ''} ${route.className || ''}`.trim()}
                  aria-current={isActive ? 'page' : undefined}
                >
                  <SpectrumHover bands={5} lineW={6} gap={3} maxH={1} active={isActive} flat={isActive} flatLevel={0.45} hoverSpeed={4} color={isActive ? [255, 255, 255] : [0, 255, 0]} />
                  <span className="navbar-label">{route.label}</span>
                </a>
              );
            })}
          </div>
        </div>
      </nav>

      { this.state.menu === 'introduction' ? <Introduction onNavigate={this.navigateTo} /> : null }

      { this.state.menu === 'advisory' ? <Advisory onNavigate={this.navigateTo} /> : null }

      { this.state.menu === 'products' ? <Products /> : null }


      { this.state.menu === 'services' ? <div className="">
  	    <div className="services-background">
  	    </div>

        <div className="intro-shield">
        </div>
    
        <div className="content" style={{ marginTop: "150px"}}>
          <h2>
            CONSULTING
          </h2>
          <h3>
            We consult in R&D, audit, finance, forensics, IT and difficult problems.
          </h3>
        </div>
  	  
  	    <div className="content" style={{ width: "calc(100vw)", minHeight: "50vh", marginLeft: "0px", paddingTop: "50px", paddingLeft: "100px", paddingRight: "100px", marginRight: "0px", marginTop: "150px", backgroundColor: "#191919", borderRadius: "0px" }}>
          <h2>CASE STUDIES</h2>
  	      <p style={{ marginBottom: "20px"}}>
            <strong style={{ color: "#FFFFFF"}}>Case Study I:  Fish Matching for Oceanic Applications</strong>
          </p>
          <p style={{ marginBottom: "20px"}}>
            In 2021, we developed a fish matching system for an Australian client as an R&D project.  The system could match a single fish from a single image over a database of millions of fish.
          </p>
          <div>
            <img className="product-image" src={FishMatcherTech2Image} alt="Fish identification feature comparison" />
            <img className="product-image" src={FishMatcherTech1Image} alt="Fish identification feature extraction" />
            <img className="product-image" src={FishMatcherImage} alt="Fish matcher application" />
          </div>
          <p style={{ marginBottom: "20px"}}>
            The system was developed using deepnets (in Tensorflow) to identify salient features in the fish and to match fish features like a fingerprint.  
            We achieved a performance of matching a single fish to the 1000 or more sample fish database of 2s.
          </p>
          <p style={{marginBottom: "100px"}}>
            In the development of the system, we developed an AI infrastructure for managing new trained models and
            native performance code for various complex algorithms.  Relentless has a 20 year track record in advanced machine learning and AI applications.
            This examples highlights our commerical efficiency in creating something realistically deployable.
          </p>
          <p style={{ marginBottom: "20px"}}>
            <strong style={{ color: "#FFFFFF"}}>Case Study II:  Large Scale Financial Transaction Reconciliation</strong>
          </p>
          <p style={{ marginBottom: "20px"}}>
            In 2022, we developed infrastructure on top of Google BigQuery to analyze many terabytes of bank transactions against a regulator's external database.
            Bank transactions were extracted from a legacy banking system typical of big banks and had to be compared based on various identifiers including timing, source and client.
            The project took 3 weeks to execute and a complete analysis of discrepancies was calculated.
          </p>
          <p style={{ marginBottom: "100px"}}>
            At Relentless, we have developed advanced tools for analyzing complex data that needs to be de-duplicated or matched in forensic or audit function. 
            These tools can handle petabyte scale problems and will work in real-time for per transaction analyses.  Email us for more information.
          </p>
          <p style={{ marginBottom: "20px"}}>
            <strong style={{ color: "#FFFFFF"}}>Case Study III:  Industrial VR and Computer Graphics</strong>
          </p>
          <p style={{ marginBottom: "20px"}}>
            We are currently developing a platform called Wrath written in Rust and built on the Vulkan graphics framework that can display high-end
            raytraced (DLSS) graphics.  A demand has been noted for highly realistic visualization of industrial operations.  We built the platform with
            reliability in mind (Rust enforces very strict code) and a server based supply of data.
          </p>
          <div>
            <img className="product-image-larger" src={WrathImage} alt="Wrath industrial visualization engine" />
          </div>
          <p style={{ marginBottom: "100px"}}>
            These advanced visualization tools, along with Konjur3D (our editting software), can enable rapid population of a VR training environments or
            control center visuals to optimize mine or industrial operations.  We are partnering with various industrial automation groups to embed our custom 
            engine in their toolchain.
          </p>
          <h2>OUR SERVICES</h2>
          <p style={{ marginBottom: "20px"}}>
  	        <strong style={{ color: "#FFFFFF"}}>Audit</strong> - The auditing industry is supported by analytics, technology specialists and compliance experts.  We provide many of these services with 
            particular strength in banking.  It is impossible to separate accurate comprehension of an audit client's technology from their financial statement.  We assist in bridging that understanding.  We
            also automate the processing of general ledgers and the search of accounting irregularities or anomalies.
  	      </p>
          <p style={{ marginBottom: "50px"}}>
  	        Avarice, initially built as an ERP, is often used to process client ERP data to assist in the internal and external audit processes.  Avarice assists in the following elements of audit:
            <ul>
              <li>Audit process management</li>
              <li>Accounts receivable (Trade receivables) aging and impairment analysis</li>
              <li>Accounts payable (Trade payables) and procurement risk analysis</li>
              <li>General ledger analysis and auto-allocation</li>
              <li>Anomalie detection (numeric, pattern based or via trained deepnet)</li>
              <li>Contract to financial evidence verification</li>
              <li>Governance checklist management</li>
              <li>Financial statement fair presentation analysis</li>
            </ul>
  	      </p>
  	      <p style={{ marginBottom: "50px"}}>
  	        <strong style={{ color: "#FFFFFF"}}>Banking Policy and Systems</strong> - Relentless has spent a decade working in the banking environment.  We've assisted in the development of policy 
            documentation, the design of banking infrastructure and software, and the development of fraud detection solutions.  We have a large network of professionals and long term relationships with core
            industry institutions in government, investigation and certification.
  	      </p>
  	      <p style={{ marginBottom: "50px"}}>
  	        <strong style={{ color: "#FFFFFF"}}>Engineering</strong> - Relentless offers engineering services in several fields including financial engineering, optics and camera design
  	        and electronics.  We also have extensive experience in sensor design for applications like spectrometry or security
  	        systems.  We also consult in the military domain, but predominantly in sensor systems and drones.
  	      </p>
  	      <p style={{ marginBottom: "50px"}}>
  	         <strong style={{ color: "#FFFFFF"}}>Fraud investigation</strong> - Relentless prides itself in the widespread application of its forensics and fraud detection systems.  We have consulted and deployed systems in the public and private sector and 
             pride ourselves in helping stem a growing white collar crime problem in Southern Africa.  Evidence collection, processing and readying for court are functions we execute on a monthly basis.  Our automation technologies
             increase our efficiency to a great extent.
  	      </p>
          <p style={{ marginBottom: "50px"}}>
  	         <strong style={{ color: "#FFFFFF"}}>IT</strong> - Have a hard IT problem you need solved?  Get in contact.  You'll be surprised what we've confronted in the last decade.
             Cloud systems and machine learning are our speciality.
  	      </p>
          <div style={{ width: "100%", textAlign: "center"}}>
            <img style={{ width: "400px" }} className="service-cycle" src="service-cycle.png" alt="Relentless service cycle" />
          </div>
        </div>
  	  </div>
  	  :
  	  null
  	  }
  	  
      { this.state.menu === 'ventures' ? <div className="">
      <VenturesBackground />

        <div className="intro-shield">
        </div>

        <div className="content" style={{ marginTop: "50px", minHeight: "60vh", paddingBottom: "80px"}}>

          <CrtTitle text="VENTURES" style={{ marginBottom: "50px" }} />

          <div className="page-body">
            <div className="intro-column" style={{display: "flex", flexWrap: "wrap", alignItems: "flex-start", marginBottom: "70px", background: "rgba(0, 0, 0, 0.75)", padding: "25px 30px", borderRadius: "10px", fontSize: "0.8em"}}>
              <div style={{marginRight: "35px", marginBottom: "15px", flexShrink: 0, width: "130px", display: "flex", alignItems: "center", justifyContent: "center"}}>
                <a href="https://www.stygianoak.com" target="_blank" rel="noreferrer">
                  <img src={StygianOakLogo} alt="Stygian Oak Studio" style={{width: "130px", height: "auto", borderRadius: "10px"}} />
                </a>
              </div>
              <div style={{flex: "1 1 300px"}}>
                <h2 className="card-heading">STYGIAN OAK STUDIOS</h2>
                <span style={{display: "block", fontSize: "0.8em", lineHeight: "1.7em", color: "#CCCCCC", marginBottom: "16px"}}>
                  Stygian Oak is an independent game development studio creating high-fidelity video games and AR/VR experiences.
                  The studio uses a custom built toolset for modelling and a custom built high-end raytracing graphics engine, and
                  is currently developing its first title, The Null, a sci-fi metroidvania.
                </span>
                <a href="https://www.stygianoak.com" target="_blank" rel="noreferrer"><strong style={{ color: "#FFFFFF", fontSize: "0.8em"}}><FontAwesomeIcon icon="external-link-alt" />&nbsp;&nbsp;VISIT WWW.STYGIANOAK.COM</strong></a>
              </div>
            </div>
          </div>
        </div>
  	  </div>
  	  :
  	  null
  	  }

{ this.state.menu === 'privacy' ? <Privacy />
  	  :
  	  null
  	  }
  	  
      { this.state.menu === 'contact' ? <div style={{background: '#000000'}}>

        <div className="content-contact">
          <ContactNoise />
          <CrtTitle text="CONTACT" className="contact-title" scale={1} rows={19} glitch align="left" />
          <p style={{fontSize: "0.8em", marginTop: "10px"}}>
            Please contact us at <a href="mailto:jon@relentless.co.za"><strong style={{ color: "#FFFFFF"}}>jon@relentless.co.za</strong></a>
  	      </p>
  	      
  	    </div>
  	  </div>
  	  :
  	  null
  	  }
  	  
      { this.state.menu === 'lander' ? <div>
          <h1 className="visually-hidden">MOON LANDER</h1>
          <Lander></Lander>
  	      
  	  </div>
  	  :
  	  null
  	  }
  	 
  	  
      <footer className="legal">
        <div className="legal-image">
          <img width="100px" src="relentless-logo.png" alt="Relentless" />
        </div>
        <p>&copy; Copyright 2014&ndash;{new Date().getFullYear()} Relentless Partners (Pty) Ltd. All rights reserved.</p>
        <p className="legal-privacy">This site uses no cookies or analytics.</p>
      </footer>
    </section>
    );
  };
}

export default App;
